import { IRunningActivities } from '../../interface/RunningActivities.interface';
import { FC, useEffect, useMemo, useState } from 'react';
import { RunningActivitiesLoading } from './RunningActivitiesLoading';
import NoRunningActivities from './NoRunningActivities';
import Activities from './Activities';
import { RunningActivitiesContainer } from './RunningActivities.style';

interface RunningActivitiesProps {
	runningActivities: IRunningActivities[];
	loading: boolean;
	refetch;
}

const RunningActivities: FC<RunningActivitiesProps> = ({ runningActivities, loading, refetch }) => {
	const [activeTab, setActiveTab] = useState(0);
	const tabs = useMemo<string[]>(() => {
		return ['Tournament', 'Champions'];
	}, []);
	if (loading) {
		return <RunningActivitiesLoading />;
	}

	return (
		<RunningActivitiesContainer>
			<div className="home__headers overflow-hidden">
				<div className="flex items-center bg-[#01ABC1]">
					{tabs.map((tab, i) => {
						return (
							<div
								key={`teams-${i}`}
								onClick={() => setActiveTab(i)}
								className={`header__toggle__tab text__default w-full px-8 py-6 text-center font-manropeBold text-white ${
									activeTab === i ? 'bg-[#0C7C8A]' : 'bg-[##01ABC1]'
								}
								${i === 1 && 'pointer-events-none cursor-default opacity-50'}
								cursor-pointer transition-colors duration-300`}
							>
								{tab}
							</div>
						);
					})}
				</div>
			</div>
			<div className="activities__container w-full overflow-auto rounded-bl-3xl rounded-br-3xl border bg-white">
				{runningActivities?.length > 0 ? (
					<div>
						{runningActivities.map((activity, i) => {
							return <Activities activity={activity} key={`activity-${activity.slug}`} refetch={refetch} />;
						})}
					</div>
				) : (
					<NoRunningActivities />
				)}

				<div className="flex items-center justify-between"></div>
			</div>
		</RunningActivitiesContainer>
	);
};

export default RunningActivities;
